/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class Custom {
		get config(){
			return {
				'customVis':{
					'isCustomVis': true,
					'isRecommendable': false,
					'aggregateAndSortOnClient':true,
					'queryHints':{
						'multiEdgeSort':true
					},
					'includeAllProperties': true,
					'ignoreElementColor': true,
					'listenForPropChanges': [],
					'slots': {
						'color': {
							'sort': 'asc',
							'icon': 'colorBy'
						},
						'repeatHorizontal': {
							'icon': 'multiplier_h',
							'sort': 'asc'
						},
						'repeatVertical': {
							'icon': 'multiplier_v',
							'sort': 'asc'
						}
					},
					'properties': {
						'widget.data.truncate': {
							active: false,
							defaultValue: true
						},
						'colors.series': {
							'defaultValue': false
						}
					},
					'bundleInclude': [],
					'config': {
						'include': [
							'widget.data.truncate',
							'widget.iterator'
						]
					}
				}
			};
		}
	}
	return Custom;
});
